<template>
    <div>
        <app-sub-title text="Consignas" />
        <b-row v-if="!isVigilance">
            <b-col cols="12" md="6" lg="3">
                <b-btn variant="primary" class="btn-block" @click="startSaveDuty()"><i class="fa fa-pencil-square-o"></i> Crear consigna</b-btn>
            </b-col>
        </b-row>
        <div class="filters">
            <app-sub-title text="Filtros" />
            <b-card>
                <div class="card-text">
                    <b-row>
                        <b-col cols="12" md="12" lg="8">
                            <app-form-select-input
                                placeholder="Tipo consigna" 
                                :options="type" 
                                v-model="filters.type"
                            />
                        </b-col>
                        <b-col cols="12" md="12" lg="2">
                            <b-btn variant="primary" @click="applyFilters()" class="btn-block"><i class="fa fa-filter"></i> Filtrar</b-btn>
                        </b-col>
                        <b-col cols="12" md="12" lg="2">
                            <b-btn variant="primary" @click="cancelFilter"  class="btn-block"><i class="fa fa-times-circle"></i> Reiniciar</b-btn>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        </div>
        <div>
            <div class="alert alert-success" v-if="!duties.length">
                ¡No hay datos! 
            </div>  
        </div>
        <div>
            <div class="alert alert-success mt-3" v-if="!isVigilance">
                Solo las consignas oficiales <i class="fa fa-check"></i> son validas como labores del turno
            </div>  
        </div>   
        <app-table-duties-list-vigilance
            :data="data"
            :on-change-page="onChangePage"
            :see-card="seeCard"
            :start-remove="startRemove"
            :start-update="startUpdate"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Confirmación" id="duty-remove">
            <div slot="body">
                <h3>¿Esta seguro que desea eliminar esta consigna?</h3>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteDuty(selectDuty)">
                    <i class="fa fa-trash" aria-hidden="true"></i> Confirmar Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Formulario de consigna" id="duty-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-duty-form id="duty-form-vigilance" :the-client-id="client.id" :my-duty="selectDuty" :onSave="onSave"></app-duty-form>
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('duty-form-vigilance.save')"> Guardar</button>
            </div>
        </app-pop-up>

        <app-pop-up id="view-duty" title="Consigna">
            <div slot="body">
                <div class="row">
                    <div class="col-12 col-sm">
                        <div>
                            <h5>Fecha creación</h5>
                            <label>{{selectDuty.created_at | datetime}}</label>
                        </div>
                    </div>
                </div>
                <br>
                <h5 style="text-align:center">
                    <label for="description">Descripción</label>
                </h5>
                <textarea type="text" id="description" class="form-control" disabled="true" cols="60" rows="8" v-model="selectDuty.description"></textarea>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
    import dutiesRepository from '../../../repositories/duties.repository.js';
    import { required } from 'vuelidate/lib/validators';
    import DutyForm from '../../Admin/Duties/DutyForm.vue';
    import SubTitle from '../../UI/Layout/SubTitle.vue';
    import TableDutiesListVigilance from './TableDutiesListVigilance/TableDutiesListVigilance.vue';
    export default {
        components: {
            appDutyForm: DutyForm,
            appSubTitle: SubTitle,
            appTableDutiesListVigilance: TableDutiesListVigilance
        },
        data() {
            return {
                page: 1,
                duties: [],
                selectDuty: '',
                isVigilance: false,
                filters: {
                    name: '',
                    type: ''
                },
                data: {},
                type: [
                    {name: 'General', id:1 },
                    {name: 'Específica', id: 0}
                ],
                sort: {
                    sortBy: 'client_id',
                    sortDir: 'desc'
                }
            };
        },

        methods: {
            onSave() {
                this.$bus.$emit('duty-form.close');
                if(this.isVigilance){
                    this.loadDutiesApprovedAndGenerals();
                }else{
                    this.loadDuties();
                }
            },
            cleanForm() {
                this.$bus.$emit('duty-form-vigilance.clean');
            },
            loadDuties() {
                const dr = Object.assign({}, dutiesRepository);
                const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
                dr.loadDutiesClientAndGeneral(this.client.id , filters, this.page)
                    .then(data => {
                        this.data = data;
                        this.duties= data.data;
                    })
                    .catch(error =>
                        toastr.error('Ocurrio un error al cargar las consignas')
                    );
            },
            loadDutiesApprovedAndGenerals(){
                const dr = Object.assign({}, dutiesRepository);
                const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
                dr.loadGeneralsAndSpecificsApproved(this.client.id , filters, this.page)
                    .then(data => {
                        this.data = data;
                        this.duties= data.data;
                    })
                    .catch(error =>
                        toastr.error('Ocurrio un error al cargar las consignas')
                    );
            },
            deleteDuty(duty) {
                const dr = Object.assign({}, dutiesRepository);
                dr.deleteDuty(duty.id, this.user.id)
                    .then(data => {
                        if (data.status) {
                            toastr.success(data.msg);
                            if(this.isVigilance){
                                this.loadDutiesApprovedAndGenerals();
                            }else{
                                this.loadDuties();
                            }
                            this.$bus.$emit('duty-remove.close');
                        } else {
                            toastr.error(data.msg);
                        }
                    })
                    .catch(error => {
                        toastr.error('No se pudo borrar la consigna');
                    });
            },
            startRemove(duty) {
                this.selectDuty = duty;
                this.$bus.$emit('duty-remove.open');
            },
            startUpdate(duty) {
                this.selectDuty = Object.assign({}, duty);
                this.$bus.$emit('duty-form.open');
            },
            startSaveDuty() {
                this.selectDuty = '';
                this.$bus.$emit('duty-form.open');
            },
            seeCard(duty){
                this.selectDuty = duty;
                this.$bus.$emit('view-duty.open');
            },
            onChangePage(page){
                this.page = page;
                if(this.isVigilance){
                    this.loadDutiesApprovedAndGenerals();
                }else{
                    this.loadDuties();
                }
            },
            cancelFilter() {
                this.page = 1;
                Object.keys(this.filters).map(key => this.filters[key] = '');
                if(this.isVigilance){
                    this.loadDutiesApprovedAndGenerals();
                }else{
                    this.loadDuties();
                }
            },
            applyFilters(){
                this.page = 1;
                if(this.isVigilance){
                    this.loadDutiesApprovedAndGenerals();
                }else{
                    this.loadDuties();
                }
            },
            onSort(ctx) {
                this.sort.sortBy = ctx.sortBy;
                this.sort.sortDir = ctx.sortDir;
                if(this.isVigilance){
                    this.loadDutiesApprovedAndGenerals();
                }else{
                    this.loadDuties();
                }
            }
        },
        
        created() {
            this.isVigilance = this.user.profile.slug === 'vigilante' ? true: false;
            if(this.isVigilance){
                this.loadDutiesApprovedAndGenerals();
            }else{
                this.loadDuties();
            }
        }
    };
</script>